import React from "react";
import { Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import "./ManagementLayout.css";
import DriverManagementView from "./driver/DriverManagementView";
import FleetManagementView from "./fleet/FleetManagementView";
import OdometerView from "./odometer/OdometerView";
import Sidebar, { SidebarMenuItem } from "../components/Sidebar";
import { Vehicle, Driver } from "../data/database";

interface ManagementLayoutProps {
    vehicles: Vehicle[];
    setVehicles: React.Dispatch<React.SetStateAction<Vehicle[]>>;
    drivers: Driver[];
    setDrivers: React.Dispatch<React.SetStateAction<Driver[]>>;
}

const mgmtMenuItems: SidebarMenuItem[] = [
    {
        id: "fleet",
        label: "차량 관리",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="3" width="15" height="13" rx="2" ry="2"></rect>
                <path d="M16 8h4l3 3v5h-7V8z"></path>
                <circle cx="5.5" cy="18.5" r="2.5"></circle>
                <circle cx="18.5" cy="18.5" r="2.5"></circle>
            </svg>
        ),
    },
    {
        id: "driver",
        label: "운전자 관리",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
        ),
    },
    {
        id: "odometer",
        label: "주행거리 관리",
        icon: (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 20a8 8 0 1 1 8-8"></path>
                <line x1="12" y1="12" x2="17" y2="9"></line>
                <circle cx="12" cy="12" r="1.5"></circle>
            </svg>
        ),
    },
];

export default function ManagementLayout({
    vehicles,
    setVehicles,
    drivers,
    setDrivers,
}: ManagementLayoutProps) {
    const navigate = useNavigate();
    const location = useLocation();

    // Determine active item from URL path
    const pathParts = location.pathname.split("/");
    const currentTab = pathParts[pathParts.length - 1];
    const activeTab = mgmtMenuItems.some(item => item.id === currentTab) ? currentTab : "fleet";

    return (
        <div className="management-layout">
            <Sidebar
                title="관리"
                titleIcon={
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                }
                menuItems={mgmtMenuItems}
                activeItem={activeTab}
                onSelect={(id) => navigate(`/management/${id}`)}
            />
            <div className="management-content" style={{ padding: "0 24px", overflowY: "auto", height: "100%" }}>
                <Routes>
                    <Route index element={<Navigate to="fleet" replace />} />
                    <Route path="fleet" element={
                        <FleetManagementView
                            vehicles={vehicles}
                            setVehicles={setVehicles}
                            drivers={drivers}
                            setDrivers={setDrivers}
                        />
                    } />
                    <Route path="driver" element={
                        <DriverManagementView
                            drivers={drivers}
                            setDrivers={setDrivers}
                            vehicles={vehicles}
                            setVehicles={setVehicles}
                        />
                    } />
                    <Route path="odometer" element={<OdometerView vehicles={vehicles} />} />
                </Routes>
            </div>
        </div>
    );
}
